import { TaskCheckGraphQLService } from './task-check.service';

export interface TaskCheckServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

export class TaskCheckRepeatGraphQLService
    extends TaskCheckGraphQLService
    implements TaskCheckServiceInterface
{
    public getEntityName(): string {
        return 'taskCheck';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            taskProcessType: true,
            name: true,
            ticket: { code: true, id: true },
            code: true,
            device: { name: true, id: true },
            assigneeName: true,
            assigneeId: true,
            taskCheckStatus: true,
            createdDate: true,
        };
    }
}
